/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Ready_RedoInputs */



/**
* | output |
* | --- |
* | "Answer the questions again" |
*
* @param {Tournament_Wiz_Ready_RedoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_ready_redo = /** @type {((inputs?: Tournament_Wiz_Ready_RedoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Ready_RedoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Répondre à nouveau aux questions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Responder de nuevo a las preguntas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Responder às perguntas de novo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rispondi di nuovo alle domande")
	return /** @type {LocalizedString} */ ("Answer the questions again")
});